@use '../../style/theme';
@use '../../style/rest';

.stripe-payment-sheet-wrap {
  @include rest.rest;

  display: block;
  width: 100%;
  background: #fff;
  padding: 32px 16px;
  .StripeElement {
    padding: 8px 16px;
    min-height: 64px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    > .__PrivateStripeElement {
      width: 100%;
    }
  }

  .stripe-heading {
    font-size: 24px;
    font-weight: bold;
    color: var(--color-heading-text);
    margin-bottom: 24px;
  }
  .stripe-section-title {
    font-size: 14px;
    font-weight: bold;
    color: var(--color-label);
    margin-bottom: 8px;
  }
  .payment-info {
    margin-top: 8px;
  }
  .stripe-element-errors {
    margin-top: 8px;
    font-size: 14px;
    color: var(--color-text-error);
  }
  button {
    display: block;
    color: var(--color-button-text);
    background-color: var(--color-primary);
    width: 100%;
    text-align: center;
    padding: 16px 16px;
    font-size: 18px;
    border-radius: 6px;
    min-height: 42px;
    &:disabled {
      color: var(--color-button-text-disabled);
    }
  }
}
